import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video",
  "use": "icon-video-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-video\"><path d=\"M726.624 64L864 201.376V960H160V64h566.624z m-24.256 32H192v832h640V229.92h-65.6a64 64 0 0 1-64-64L702.368 96z\" fill=\"#409EFF\" p-id=\"3989\" /><path d=\"M576 416a32 32 0 0 1 32 32v41.6l96-57.6v192l-96-57.6V608a32 32 0 0 1-32 32h-224a32 32 0 0 1-32-32v-160a32 32 0 0 1 32-32h224z\" fill=\"#409EFF\" p-id=\"3990\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol